<template>
	<div id="login">
		<div id='tisp' v-if="tispshow==1">
			<!-- 未实名制弹窗 -->
			<div class="centent">
				<h5>忘记密码<span class="line"></span></h5>
				<i class="el-icon-close del" @click="del(1)"></i>
				<div class="inputbox" :class="usererr?'':'err'">
					<el-input class="input border0" placeholder="输入股权账户号/股东编号" suffix-icon="el-icon-user-solid" v-model="user"></el-input>
					<p class="inputtisp">请输入股东账号</p>
				</div>
				<div class="inputbox code" :class="codeerr?'':'err'">
					<el-input class="input border0" type="text" placeholder="输入验证码" v-model="code"></el-input>
					<div class="codebox" @click="getcode()">
						<span class="imgbox"><img :src="codeimg" alt=""></span>
						<span class="buttonbox">
							<el-link style="font-size:12px" type="primary">换一张</el-link>
						</span>
					</div>
					<p class="inputtisp">请输入验证码</p>
				</div>
				<div class="inputbox">
					<el-button round class="registerbutton" @click="login()">确定</el-button>
				</div>
			</div>
		</div>
		<div id='tisp' v-if="tispshow==2">
			<!-- 未实名制弹窗 -->
			<div class="centent">
				<h5>重置密码<span class="line"></span></h5>
				<i class="el-icon-close del" @click="del(2)"></i>
				<div class="inputbox">
					<el-input class="input border0 color" type="tel"  autocomplete="new-password" maxlength="11" placeholder="请输入预留手机号" suffix-icon="el-icon-user-solid" readonly :value="'预留手机号：'+phone.substr(0, 3) + '****' + phone.substr(7, 11)"></el-input>
				</div>
				<div class="inputbox code" :class="codeerr?'':'err'">
					<el-input class="input border0" type="text" maxlength="6" autocomplete="new-password" placeholder="输入验证码" v-model="code"></el-input>
					<div class="codebox getcodebox" style="height: auto;">
						<el-button round class="getcode" v-if="time==60" @click="getphonecode">获取验证码</el-button>
						<el-button round class="getcode" v-else type="button">{{time}}s后重新获取</el-button>
					</div>
					<p class="inputtisp">请输入验证码</p>
				</div>
				<div class="inputbox" :class="passw1err?'':'err'">
					<el-input class="input border0" maxlength="6"  autocomplete="new-password" type="password" placeholder="输入新密码(6位不重复数字)" v-model="passw1"><i slot="suffix"  class="passwordimg"></i></el-input>
					<p class="inputtisp">新密码需为6位不重复数字</p>
				</div>
				<div class="inputbox" :class="passw2err?'':'err'">
					<el-input class="input border0" maxlength="6"  autocomplete="new-password" type="password" placeholder="再次输入新密码" v-model="passw2"><i slot="suffix" class="passwordimg"></i></el-input>
					<p class="inputtisp">新密码需为6位不重复数字</p>
				</div>
				<div class="inputbox">
					<el-button round class="registerbutton" @click="submin()">确定</el-button>
				</div>
			</div>
		</div>
		<div id="tispma" v-if="tispshow==3">
			<!-- 未实名制弹窗 -->
			<div class="centent">
				<h5>提示</h5>
				<i class="el-icon-close del" @click="tispshow=1"></i>
				<p class="codetitle">
					<i class="el-icon-warning"></i>您尚未进行经实名认证
				</p>
				<p class="textp">请扫描下方二维码进入托管中心微信公众号办理实名认证后，再选择【忘记密码】功能重置密码</p>
				<div class="code">
					<img :src="urlimg" alt />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	import {
		url
	} from "../../libs/api/index.js";
	export default {
		components: {},
		name: 'ForgetPassword',
		data() {
			return {
				urlimg: require('../../assets/ma.jpg'),
				tispshow: 1, //登录提示
				code: '',
				codeerr:true,
				codeimg:'',
				codetext:'',
				/* 验证码 */
				user: '',
				usererr:true,
				/* 股权账户号/股东编号 */
				phone: '',
				/* 手机号 */
				passw1: '',
				passw1err:true,
				/* 新密码1 */
				passw2: '',
				passw2err:true,
				/* 新密码2 */
				Sharedata:'',
				time:60,
				cleattime:''

			}
		},
		watch:{
			user(val){
				if(val==''){
					this.usererr=false
				}else{
					this.usererr=true
				}
			},
			code(val){
				if(val==''){
					this.codeerr=false
				}else{
					this.codeerr=true
				}
			},
			tispshow(val){
				if(val==2){
					this.codeerr=true
				}
				this.time=60;
			},
			passw1(val){
				let ispass = false
				for (let i = 0, len = val.length; i < len; i++) {
					for (let j = 0, lenj = val.length; j < lenj; j++) {
						if (val[i] != val[j]) {
							ispass = true;
							break;
						}
					}
				}
				if (val.length == 6 && ispass && !isNaN(val)) {/* 格式满足 */
					this.passw1err=true
				}else{
					this.passw1err=false
				}
			},
			passw2(val){
				let ispass = false
				for (let i = 0, len = val.length; i < len; i++) {
					for (let j = 0, lenj = val.length; j < lenj; j++) {
						if (val[i] != val[j]) {
							ispass = true;
							break;
						}
					}
				}
				if (val.length == 6 && ispass && !isNaN(val)) {/* 格式满足 */
					this.passw2err=true
				}else{
					this.passw2err=false
				}
			}
		},
		methods: {
			del(type) {/* 回退 */
				if (type == 1) { //股东号
					this.$router.push({
						path: '/'
					})
				} else { //设置新密码
					this.tispshow = 1;
					this.getcode()
					this.code='';/* code是公用的，所以这里要清空 */
				}
			},
			getphonecode() {/* 获取短信验证码 */
				let user = this.user
				if (user.length < 12) {
					let len = user.length;
					for (let i = 1; i < (12 - len); i++) {
						user = '0' + user;
					}
					user = '9' + user
				}
				axiosPost.getphone({phone:this.phone,shareholderCode:user}).then((res) => {
					window.console.log(res)
					if(res.data.code==200){
						window.console.log(res)
						this.$message.warning({
							showClose: true,
							message: '验证码已发送到手机，请注意查收！',
							duration: 5000,
						});
						this.settime();
					}else{
						this.$message.error({
							showClose: true,
							message: res.data.msg,
							duration: 5000,
						});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			settime(){
				let t=this;
				this.cleattime=setInterval(function(){
					t.time--;
					if(t.time==0){
						t.time=60;
						clearInterval(t.cleattime)
					}
				},1000)
			},
			login() { /* 验证用户是否实名 */
				// this.tispshow = false;
				let user = this.user
				if(this.user==''){
					this.usererr=false
				}
				if(this.code==''){
					this.codeerr=false
				}
				if(!this.codeerr || !this.usererr){
					return false;
				}
				if (user.length < 12) {
					let len = user.length;
					for (let i = 1; i < (12 - len); i++) {
						user = '0' + user;
					}
					user = '9' + user
				}
				window.console.log(this.code,this.codetext)
				if(this.code.toUpperCase() != this.codetext.toUpperCase()){
					this.$message.error({
						showClose: true,
						message: '验证码不正确！',
						duration: 5000,
					});
					this.getcode()
					return false
				}
				axiosPost.getShare({shareholderCode:user}).then((res) => {
					if(res.data.data && res.data.code==200){
						this.Sharedata = res.data.data
						this.phone=this.Sharedata.phone
						if(!this.Sharedata.authenticationStatus || this.Sharedata.authenticationStatus==0){
							this.$message.error({
								showClose: true,
								message: '此账号没有实名认证！',
								duration: 5000,
							});
							this.tispshow = 3;
						}else{
							this.code='';/* code是公用的，所以这里要清空 */
							this.tispshow = 2;
						}
					}else{
						this.$message.error({
							showClose: true,
							message: '此账号没有实名认证！',
							duration: 5000,
						});
						this.tispshow = 3;
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			submin() { /* 密码重置提交 */
				let t = this;
				let user = this.user
				if (user.length < 12) {
					let len = user.length;
					for (let i = 1; i < (12 - len); i++) {
						user = '0' + user;
					}
					user = '9' + user
				}
				if (this.code == "") {
					this.codeerr = false;
				}
				if (this.passw1 == "") {
					this.passw1err = false;
				}
				if (this.passw2 == "") {
					this.passw2err = false;
				}
				if(!this.codeerr || !this.passw1err || !this.passw2err){
					return false;
				}
				if (t.passw1 != t.passw2) {
					this.$message.error({
						showClose: true,
						message: '两次新密码不一致，请重新输入!',
						duration: 5000,
					});
					return false
				}
				let params = '4901;' + user + ';' + t.passw1 + ';;;;;'
				axiosPost.getdata(params,t.code).then((res) => {
					if (res.data.filter && res.data.filter.msg) {
						this.$alert(res.data.filter.msg, '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.console.log(action);
								if (res.data.filter.code == 0) {
									share()
								}else{
									this.$router.push({
										path: "/login"
									});
								}
							}
						});
					}else{
						share()
					}
					function share(){
						let str = res.data.data
						let code = str.slice(0, str.indexOf(';'))
						if(res.data.code==200){
							if (code == 200) {
								t.$message.success({
									showClose: true,
									message: '重置密码成功，请重新登录！',
									duration: 5000,
								});
								setTimeout(function() {
									t.$router.push({
										path: '/'
									})
								}, 500);
							} else if(code == 400){
								t.$message.error({
									showClose: true,
									message: '重置密码失败，请稍后再试！',
									duration: 5000,
								});
								t.getcode();
							}else{
								t.$message.error({
									showClose: true,
									message: str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3) + '，请稍后再试！',
									duration: 5000,
								});
								t.getcode();
							}
						}else{
							t.$message.error({
								showClose: true,
								message: res.data.msg,
								duration: 5000,
							});
						}
						
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			getcode() {/* 获取图片验证码 */
				axiosPost.getcode('').then((res) => {
					if(res.data.code==200){
						this.codeimg=url+'app/file/downByTmpPath?path='+res.data.data.path
						this.codetext=res.data.data.validCode
					}else{
						this.$message.error(res.data.msg);
					}
				}).catch((res) => {
					window.console.log(res)
				})
			}
		},
		mounted() {
			this.getcode()
		},

	}
</script>

<style lang="less" scoped>
	#tispma {
		background-color: rgba(0, 0, 0, 0.56);
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	
		h5 {
			font-size: 22px;
			text-align: center;
			color: #fff;
			font-weight: 500;
		}
	
		.del {
			position: absolute;
			top: 20px;
			right: 20px;
			font-size: 24px;
			color: rgba(255, 255, 255, 0.7);
			cursor: pointer;
		}
	
		.centent {
			position: absolute;
			width: 380px;
			height: 370px;
			top: 50%;
			left: 50%;
			margin-top: -190px;
			margin-left: -175px;
			font-size: 0;
			background-color: rgba(255, 255, 255, 0.3);
			border-radius: 8px;
			text-align: center;
	
			.codetitle {
				font-size: 14px;
				color: #fff;
			}
	
			.textp {
				font-size: 16px;
				color: #fff;
				padding: 0 30px;
			}
	
			.code {
				width: 110px;
				height: 110px;
				margin: 0 auto;
				padding: 4px;
				margin-top: 30px;
				background-color: #fff;
				border: 3px solid #bdc8da;
				box-shadow: 0 0 0px 4px #fff;
				font-size: 0;
	
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
	}
	.el-input__inner:focus {
		border-color: red;
	}

	.registerbutton {
		font-size: 14px;
		background-color: #d9261c;
		color: #fff;
		width: 100%;
		border: 0px;
	}

	.code {
		.input {
			width: 55%;
			vertical-align: top;
		}

		.codebox {
			display: inline-block;
			width: 45%;
			text-align: center;
			height: 30px;
			vertical-align: 21px;
			cursor: pointer;
			.imgbox {
				width: 80px;
				text-align: center;
				font-size: 0;
				background-color: #fff;
				border-radius: 3px;
				display: inline-block;
				vertical-align: middle;
				img {
					width: 95%;
					margin: 2px 0;
				}
			}

			.buttonbox {
				display: inline-block;
				margin-left: 15px;
				vertical-align: middle;
			}
		}

		.getcodebox {
			vertical-align: 15px;
			text-align: right;
		}

		.getcode {
			color: #fff;
			background-color: #999999;
			padding-left: 15px;
			padding-right: 15px;
		}
	}
	.err.inputbox {
		.input{
			border:1px solid #f56c6c;
		}
		.inputtisp{
			text-align: left;
			font-size: 12px;
			color: #f56c6c;
			margin: 0;
			position: absolute;
			bottom:8px;
			left:15px;
		}
	}
	.inputbox {
		padding-bottom: 25px;
		position: relative;
		.input {
			border-radius: 100px;
			overflow: hidden;
			box-sizing: border-box;
			border:1px solid transparent;
		}

		.passwordimg {
			display: block;
			background: url('../../assets/password.png') no-repeat center;
			background-size: 13px 13px;
			width: 25px;
			height: 100%;
		}
	}

	.input:focus {
		border: 20px solid red;
	}

	#login {
		background: url('../../assets/loginbackground.png') no-repeat center;
		background-size: cover;
		min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;

		.content {
			margin: 0 auto;
			max-width: 100%;
			width: 1500px;
			padding: 0 90px;
		}
	}

	#tisp {
		background-color: rgba(0, 0, 0, .56);
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;

		h5 {
			font-size: 22px;
			text-align: center;
			color: #fff;
			font-weight: 500;
			position: relative;

			.line {
				position: absolute;
				bottom: -10px;
				left: 50%;
				margin-left: -15px;
				display: block;
				width: 30px;
				height: 3px;
				border-radius: 5px;
				background-color: #d9261c;
			}
		}

		.del {
			position: absolute;
			top: 20px;
			right: 20px;
			font-size: 24px;
			color: rgba(255, 255, 255, .7);
			cursor: pointer;
		}

		.centent {
			position: absolute;
			width: 380px;
			top: 50%;
			left: 50%;
			transform: translateY(-50%);
			margin-left: -175px;
			font-size: 0;
			padding: 0 30px;
			background-color: rgba(255, 255, 255, .3);
			border-radius: 8px;
			text-align: center;
		}
	}
</style>
